import React from 'react';
import { Clock, AlertCircle } from 'lucide-react';

function getTimeSince(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 30) return `${diffDays} days ago`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`;
  return `${Math.floor(diffDays / 365)} years ago`;
}

function getFreshnessColor(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
  
  if (diffDays <= 7) return 'green';
  if (diffDays <= 30) return 'blue';
  if (diffDays <= 90) return 'yellow';
  return 'red';
}

export default function DataFreshnessIndicator({ lastUpdated, label = "Last Verified" }) {
  const freshnessColor = getFreshnessColor(lastUpdated);
  const timeSince = getTimeSince(lastUpdated);
  
  const colorClasses = {
    green: 'bg-green-50 border-green-200 text-green-700',
    blue: 'bg-blue-50 border-blue-200 text-blue-700',
    yellow: 'bg-amber-50 border-amber-200 text-amber-700',
    red: 'bg-red-50 border-red-200 text-red-700'
  };
  
  const Icon = freshnessColor === 'red' ? AlertCircle : Clock;
  
  return (
    <div className={`inline-flex items-center space-x-2 px-3 py-1.5 rounded-lg border text-xs font-medium ${colorClasses[freshnessColor]}`}>
      <Icon className="h-3.5 w-3.5" />
      <span>{label}: {timeSince}</span>
      {freshnessColor === 'red' && (
        <span className="ml-1 text-red-600 font-semibold">(Verify Current)</span>
      )}
    </div>
  );
}
